// Verdict lock for the design popup (flag approvalPatchEnabled).
//
// With the flag ON, Approve/Reject are disabled and the overlay is shown
// while the hook is busy (isLoading) or a verdict PUT is in flight
// (verdictPending), so the popup cannot fire a second verdict.
//
// With the flag OFF the popup must be byte-identical to today: the overlay
// follows the hook's isLoading exactly as before, and the two buttons never
// receive a disabled attribute (`undefined` renders nothing).
export interface VerdictLockInput {
  approvalPatchEnabled: boolean;
  isLoading: boolean;
  verdictPending: boolean;
}

export interface VerdictLockState {
  overlay: boolean;
  buttonsDisabled: true | undefined;
}

export function verdictLockState({
  approvalPatchEnabled,
  isLoading,
  verdictPending,
}: VerdictLockInput): VerdictLockState {
  if (!approvalPatchEnabled) {
    return { overlay: isLoading, buttonsDisabled: undefined };
  }
  const locked = isLoading || verdictPending;
  return { overlay: locked, buttonsDisabled: locked || undefined };
}
